<template>
  <el-dialog title="上传视频" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div style="height: 300px;display: flex;">
          <el-upload style="width: 5%;" :action="api.uploadFileUrl" :headers="headers" accept=".mp4,.m4a,.aac"
                 :on-preview="handlePictureCardPreview2" :on-success="uploadPictureSuccess"
                 :show-file-list="true" :on-remove="handleRemoveVideo" :on-change="uploadPictureChange" :on-progress="upVideo"
                 list-type="picture-card" class="videoUpload">
  <!--      <div v-for="video in videoList" :key="video.url">-->
  <!--        <video width="100%" controls="controls" :src="video.url" class="avatar"></video>-->
  <!--      </div>-->
     
        <i class="el-icon-plus"></i>
      </el-upload>
      <div style="width: 90%;display: flex;margin-top: 40px;flex-wrap: wrap;">
      <div v-for="(video, index) in videoList" :key="index" class="video-container">
          <video width="100%" controls="controls" :src="video.url" class="avatar"></video>
        </div>
      </div>
                      </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import store from "@/store";

import api from "@/api/projectApi";
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'excludeId', 'siteFloorLevel', 'orgId','companyId','isWithoutEnd'],
  mixins: [selectDialogMixins],

  computed: {

    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }

  },
  watch: {
    photoUrl: {
      handler(url) {
        if (url) {
          let list = []
          if (url !== null && url !== '' && url !== undefined) {
            this.videoUrl2=url,
              console.log(url, "name55555");

          }


        } else {

        }
      },
      deep: true,
      immediate: false,
    },

    videoList: {
      handler(n) {
        if (n.length > 0) {
          console.log(this.videoList, n, "触发l此处");
          this.$emit('update:photoUrl', this.videoList)
        }
      },
      deep: true,
      immediate: false,
    },

  },
  created() {
  
  },


  data() {
    return {
      videoList:[],

      total: 0,
      filterText: '',
      data: [],

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        vedioUrl:'',
        vedioName:""
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      searchSiteAccount: null,
      selectedRow: {
        id: '', name: '', orgId: null, orgIdPath: null
      }
    };
  },


  methods: {
    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList,"151");
      // 调删除图片接口
      // deleteFileByName({ fileName: this.form.url }).then(res => {
      //   if (res.code == 200) {
      //     // this.form.url = ''
      //     // this.form.time = ''
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     });
      //     this.isShow = false
      //   }
      // })

    },
    upVideo(){
      this.$mask.open()

    },
    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList);
      // 调删除图片接口
      // deleteFileByName({ fileName: this.form.url }).then(res => {
      //   if (res.code == 200) {
      //     // this.form.url = ''
      //     // this.form.time = ''
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     });
      //     this.isShow = false
      //   }
      // })

    },
    // 视频
    handlePictureCardPreview2(file) {
      console.log(file, file.url, "99999")
      // this.videoUrl = file.url;

    },
    uploadPictureSuccess(res, file) {
      if (file.status == "success") {
        this.$message({
          message: '录音/视频上传成功',
          type: 'success'
        });
        this.$mask.close()

        console.log(res, file, '上传成功后的res视频');
        this.videoList.push({ name: file.name, url: res.data.url });
        console.log(this.videoList, "上传的视频1111");

      }
      this.isShow = true;
      this.$emit('update:photoUrl', this.videoList); // 触发更新 photoUrl 的事件
    },
    uploadPictureChange(file, fileList) {
      console.log(file, fileList)
      let _this = this
      // this.hideUpload = fileList.length >= this.limitCount;
      var audioElement = new Audio(file.url), duration;
      audioElement.addEventListener("loadedmetadata", function () {
        // _this.form.time = audioElement.duration;
        // console.log('时长：' + _this.form.time + 's')
      })
    },


    commitRow() {
      if (this.videoList !== '') {
        this.$emit('commitVideo', this.videoList)
        this.dialogClose()
      } else {
        this.$message.warning('请先上传视频')
      }
    },

  }
};
</script>
<style lang="scss" scoped>
// 装图片的  大框
::v-deep .el-upload--picture-card {
  margin:20px 10px;
  width: 70px;
  height: 70px;
  line-height: 70px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  // display:none;
  width: 0px;
  height: 0px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  width: 60px;
  height: 60px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}
::v-deep .avatar2 {
  position: absolute;
  width: 130px;
  height: 70px;
  top: 40px;
  left: 100px;
}

.avatar {
  width: 130px;
    height: 70px;
  margin-left: 20px;
}
</style>
